export default {
    title: "EBC金融集团与牛津大学合作共塑全球经济格局",
    description:
      "探索EBC金融集团与牛津大学如何联手，将学术理论与金融实践相结合，打造全球经济解决方案。",
    word1: "EBC金融集团<br class='mobile'/>携手牛津大学经济系",
    word2: "连接理论研究与金融实践，共塑全球经济新格局",
    word3: "精彩回顾",
    word4: "与我们携手",
    word5: "合作概览",
    word6: "WERD往期内容",
    word7: "特邀嘉宾",
    word8: "媒体报道",
    word9: "始于纯粹的理念：教育赋能未来",
    word10:
      `EBC金融集团坚信，塑造可持续发展的金融格局，源于专业知识的普及。`,
    word11:
      `我们携手牛津大学经济学系，通过"经济学家都干了什么"（WERD）系列研讨会，让世界顶尖学术智慧转化为面向大众的实用知识。`,
    word12:
      "以公平、责任、诚信为基石，我们共同致力于提升金融素养，启发批判思维，赋能新一代投资者、金融领袖、思想家，共同开创更开放、包容的金融未来。",
    word13: "真诚对话，深远影响",
    word14: "WERD第一期",
    word15: "“经济学家都干了什么”",
    word16: "活动详情",
    word17:
      "探讨税收规避行为对全球及区域经济的影响，强调金融素养在应对复杂经济问题中的重要性",
    word18: "演讲嘉宾",
    word19: "Dr. Abi Adams，牛津大学经济学教授，主持人",
    word20: "Dr. Sarah Clifford，牛津大学经济系教授",
    word21: "EBC金融集团（英国）CEO David Barrett出席并担任特邀演讲嘉宾",
    word22: "活动时间",
    word23: "2024年3月1日",
    word24: "（经济学家都干了什么\n2023-2024系列）",
    word25: "活动形式",
    word26: "Zoom线上直播回放",
    word27: "WERD第二期",
    word28: "维持可持续性发展：平衡经济增长与气候韧性",
    word29:
      "探讨了宏观经济政策如何在确保经济稳定的同时，帮助解决全球最迫切的环境挑战",
    word30:
      "Banu Demir Pakel 博士，会议主持人，牛津大学对外交流合作副主任兼经济学教授",
    word31: "Andrea Chiavari博士，讲座主理人及圆桌讨论嘉宾",
    word32:
      "Nicola Ranger博士，牛津大学环境变化研究全球金融组主任、牛津大学高级研究学者",
    word33: " David Barrett，EBC金融集团（英国）CEO",
    word34: "2024年11月\n（经济学家都干了什么 2024-2025期）",
    word35:
      "牛津大学经济学系首次Hybrid event（线下与线上结合研讨会），设有圆桌讨论环节",
    word36: "特邀演讲嘉宾",
    word37: "Nicola Ranger",
    word38: "牛津大学环境复原力及马丁系统韧性负责人",
    word39:
      "Nicola Ranger博士创立了牛津大学环境变化研究所的全球金融与经济组，与金融机构、中央银行和政府密切合作，推动金融、气候、自然和分析交叉领域的领先研究。Ranger 一直参与开发压力测试和情景分析方法，包括与国际货币基金组织、世界银行、NGFS和英国气候金融风险论坛合作。此外，她还在欧盟委员会EMDE可持续投资高级别专家组、英国绿色技术（分类法）咨询小组/LNAS、FCDO和伦敦政治经济学院担任顾问职务。",
    word40: "Andrea Chiavari",
    word41: "牛津大学经济系教授",
    word42:
      "Andrea Chiavari 是牛津大学经济学系教授，专注于宏观经济学，尤其是企业动态和技术变革，探索如何利用经济模型支持可持续发展。研究涉及气候变化对企业生产力和资本配置的影响，特别关注如何在不确定环境中提高经济效率和韧性，以及科技在推动经济增长中的作用。\n\n",
    word43: "Banu Demir Pakel",
    word44: "牛津大学经济系教授",
    word45:
      "Banu Demir Pakel 是牛津大学经济学系教授，专注于国际贸易和发展经济学，主要探讨企业如何应对与贸易相关的冲击，以及这种调整如何影响整体经济结果。她同时也是欧洲经济政策研究中心（CEPR）国际贸易与区域经济项目和慕尼黑CESifo研究网络的研究成员。 ",
    word46: "David Barrett",
    word47: "EBC金融集团（英国）CEO",
    word48:
      "David Barrett是EBC 金融集团 (英国) CEO ，在国际资产多元化配置、结构性风险防范领域有超过35年经验，亲历多个市场周期，曾主导全球最大投资集团美国AIG的执行和管理工作，推动了华尔街产品架构和合规风控等领域的一系列变革，为后金融危机时代的风险规避和流动性管理搭建了可行性框架。 ",
    word49: "Sarah Clifford",
    word50: "牛津大学经济学副教授",
    word51:
      "Sarah Clifford博士作为牛津大学“避税经济学”领域的学术巨擘，致力于探索避税经济学背后的经济学原理，以及税收相关的经济行为模型。Sarah Clifford博士是最早利用跨国面板数据研究MNE ETR的学者之一，主导并提出了经合组织OECD有关税基侵蚀的“GloBE”法案，极大推动了BEPS包容性框架的构建。在其最新论文《避税的全球影响及其对政策的启示》中，她深入分析了避税经济学如何在全球范围内对经济产生影响，以及政府如何通过有效的政策干预来减少这一现象。",
    word52: "Abi Adams-Prassl",
    word53: "牛津大学经济学教授",
    word54:
      "Abi Adams-Prassl教授主攻应用微观经济学，擅长通过实证方法将数据引入到决策模型中，辅助微观个体和家庭做出决策。作为英国政府科学办公室的专家组成员，Abi Adams-Prassl教授主导了英国政府的风险管理和弹性规划，并将其从短期扩展为长期目标；同时，作为跨学术和政策研究领域的权威，Abi Adams-Prassl教授还制定了英国法律体系中有关司法的量化框架，确定了大数据环境中平衡诉诸司法和开放司法原则。",
    word55: "查看更多",
    word56: "新闻动态",
    word57: "携手共启新篇",
    word58: "EBC诚邀志同道合的机构与变革先锋携手同行",
    word59: "联系我们",
    placeholder1: "贵姓/昵称",
    placeholder2: "邮箱",
    placeholder3: "手机号",
    placeholder4: "验证码",
 
};
